import styled from '../../../../styles/theme';
import { CheckoutCarMainInfoStyledOV } from '../CheckoutCarMainInfoStyled.OV';

export const CheckoutCarMainInfoStyledGBOV = styled(CheckoutCarMainInfoStyledOV)`
    .availableInWrapper {
        .availableInLabel {
            color: ${({ theme }) => theme.colors.heavyMetal};
        }
        .availableInDate {
            color: ${({ theme }) => theme.colors.heavyMetal};
            padding-left: 0.4rem;
            padding-right: 0.4rem;
            font-weight: normal;
        }
    }
`;
